// src/helpers/rutaAuditoria.js
import axios from "axios";

const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE ||
  "https://backre-miami.us-3.evennode.com";

const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const API = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

const getToken = () =>
  localStorage.getItem("token") ||
  localStorage.getItem("authToken") ||
  localStorage.getItem("jwt") ||
  "";

const authConfig = () => {
  const token = getToken();

  return token
    ? {
        headers: {
          token,
        },
      }
    : {};
};

const clean = (value) => String(value ?? "").trim();

const limpiarParametros = (params = {}) => {
  const salida = {};

  Object.entries(params).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      value !== ""
    ) {
      salida[key] = value;
    }
  });

  return salida;
};

/**
 * Consulta paginada de auditorías.
 *
 * Parámetros admitidos:
 * page
 * limit
 * desde
 * hasta
 * modulo
 * accion
 * entidad
 * resultado
 * usuario
 * q
 */
export const getAuditorias = async (params = {}) => {
  const response = await API.get("/auditorias", {
    ...authConfig(),
    params: limpiarParametros(params),
  });

  return response.data;
};

/**
 * Consulta el detalle completo de un registro.
 * Incluye datosAntes, datosDespues y metadata.
 */
export const getAuditoria = async (id) => {
  const auditoriaId = clean(id);

  if (!auditoriaId) {
    throw new Error(
      "Debe indicar el ID del registro de auditoría."
    );
  }

  const response = await API.get(
    `/auditorias/${encodeURIComponent(auditoriaId)}`,
    authConfig()
  );

  return response.data;
};

export default {
  getAuditorias,
  getAuditoria,
};